import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query'
import { useToast } from '@veracity/vui'
import { useNavigate } from 'react-router-dom'

import { productionProfilesClient } from '@/api'
import { config } from '@/config'

const BASE_ROUTE = config.links.library.productionProfiles
const BASE_QUERY_KEY = productionProfilesClient.QUERY_KEY

export const useProductionProfiles = () => {
  const { showSuccess } = useToast()
  const navigate = useNavigate()
  const queryClient = useQueryClient()

  const getProductionProfilesQuery = useQuery({
    queryKey: [...BASE_QUERY_KEY, { lockedOnly: false }],
    queryFn: () => productionProfilesClient.getAll()
  })

  const addDatasetMutation = useMutation({
    mutationFn: productionProfilesClient.addDataset,
    onSuccess: (datasetId: number) => {
      showSuccess('Dataset successfully added')
      navigate(`${BASE_ROUTE}/${datasetId}`)
    }
  })

  const cloneDatasetMutation = useMutation({
    mutationFn: productionProfilesClient.cloneDataset,
    onSuccess: (datasetId: number) => {
      showSuccess('Dataset successfully cloned')
      navigate(`${BASE_ROUTE}/${datasetId}`)
    }
  })

  const removeDatasetMutation = useMutation({
    mutationFn: productionProfilesClient.removeDataset,
    onSuccess: async () => {
      showSuccess('Dataset successfully removed')
      await queryClient.invalidateQueries({ queryKey: BASE_QUERY_KEY })
    }
  })

  return {
    productionProfilesDatasets: getProductionProfilesQuery.data || [],
    isFetching:
      getProductionProfilesQuery.isFetching &&
      !getProductionProfilesQuery.isRefetching,
    addDataset: addDatasetMutation.mutate,
    isAddDatasetInProgress: addDatasetMutation.isPending,
    cloneDataset: cloneDatasetMutation.mutate,
    isCloneDatasetInProgress: cloneDatasetMutation.isPending,
    removeDataset: removeDatasetMutation.mutate
  }
}
